// DS6.17
import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink, {
  Props as PlainButtonOrLinkProps,
} from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';

import s from './QuickSearch.scss';

export interface Props extends PlainButtonOrLinkProps {
  className?: string;
  isSelected?: boolean;
}

/** links in lozenge form (originally just for shop page) */
const QuickSearch: React.FC<Props> = ({
  children,
  href,
  className,
  isSelected,
  onClick,
  ...rest
}) => {
  return (
    <PlainButtonOrLink
      className={classnames(s['root'], className)}
      href={href}
      onClick={onClick}
      {...rest}
    >
      {children}
    </PlainButtonOrLink>
  );
};

QuickSearch.displayName = 'QuickSearch';
export default QuickSearch;
